import * as React from 'react';
import type { OwnerOrCompanyRow } from '../../helpers/opportunityReportingChartTypes';
import { OwnerOrCompanyBarChart } from '../OwnerOrCompanyBarChart';

interface TopCompaniesChartProps {
	data: OwnerOrCompanyRow[];
	isLoading?: boolean;
	className?: string;
}

export const TopCompaniesChart: React.FC<TopCompaniesChartProps> = props => (
	<OwnerOrCompanyBarChart
		{...props}
		title='Top companies by deal size'
		emptyMessage='No company linked on opportunities in the loaded data'
	/>
);
